import { render, staticRenderFns } from "./ExtinguisherReportsList.vue?vue&type=template&id=4bfc1bb1&"
import script from "./ExtinguisherReportsList.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports